import React from 'react'

export default function ZoomInIcon() {
  return (
    <svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" fill="#FFF"></circle>
      <path className="hovered" fillRule="evenodd" clipRule="evenodd" d="M19.894 21.3081C17.895 22.988 15.3154 24 12.5 24 6.14893 24 1 18.8513 1 12.5 1 6.14868 6.14893 1 12.5 1 18.8511 1 24 6.14868 24 12.5c0 2.8156-1.0122 5.3949-2.6919 7.394l5.3989 5.3988c.3907.3905.3907 1.0237 0 1.4142-.3901.3905-1.0234.3905-1.414 0l-5.399-5.3989zM22 12.5c0 5.2467-4.2534 9.5-9.5 9.5C7.25342 22 3 17.7467 3 12.5S7.25342 3 12.5 3c5.2466 0 9.5 4.2533 9.5 9.5z" fill="#AAA"></path>
      <path className="zoom-in" fillRule="evenodd" clipRule="evenodd" d="M12 12V9h1v3h3v1h-3v3h-1v-3H9v-1h3z" fill="#AAA"></path>
    </svg>
  )
}

ZoomInIcon.displayName = 'ZoomInIcon'